








































import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import {
  DELETE_FORM,
  DELETE_MANUAL_FORM,
  OPEN_REMOVE_FORM_MODAL,
  OPEN_REMOVE_FORM_MODAL_ERRORS,
  SEARCH_EMPLOYEES_CURRENT_FORM,
  SET_OPEN_REMOVE_FORM_MODAL,
} from '@/types/managerForm.types';
import { ManagerForm101Data } from '@/models/manager/ManagerForm101Data.model';
import { Form101SearchType } from '@/models/manager/enums/Form101SearchType';

@Component({})
  export default class RemoveFormModal extends Vue {

    @Action(DELETE_FORM, StoreNamespace.MANAGER) public removeForm;
    @Action(DELETE_MANUAL_FORM, StoreNamespace.MANAGER) public removeManualForm;

    @Mutation(SET_OPEN_REMOVE_FORM_MODAL, StoreNamespace.MANAGER) public setOpenRemoveFormModal;

    @Getter(OPEN_REMOVE_FORM_MODAL, StoreNamespace.MANAGER) public openRemoveFormModal!: boolean;
    @Getter(SEARCH_EMPLOYEES_CURRENT_FORM, StoreNamespace.MANAGER) public searchEmployeesCurrentForm!: ManagerForm101Data;
    @Getter(OPEN_REMOVE_FORM_MODAL_ERRORS, StoreNamespace.MANAGER) public openRemoveFormModalErrors!: string[];

    public closeDialog(): void {
      this.openRemoveFormModalErrors.length = 0;
      this.setOpenRemoveFormModal(false);
    }

    public confirmDialog(): void {
      if (this.searchEmployeesCurrentForm.searchType === Form101SearchType.ELECTRONIC){
          this.removeForm({
           formId: this.searchEmployeesCurrentForm.formId,
            officeNum: this.searchEmployeesCurrentForm.officeNum,
            idNum: this.searchEmployeesCurrentForm.idNum,
            positionNum: this.searchEmployeesCurrentForm.positionNum,
      });
      }
      if(this.searchEmployeesCurrentForm.searchType === Form101SearchType.MANUAL){
          this.removeManualForm({
            officeNum: this.searchEmployeesCurrentForm.officeNum,
            idNum: this.searchEmployeesCurrentForm.idNum,
            positionNum: this.searchEmployeesCurrentForm.positionNum,
            dateFrom: this.searchEmployeesCurrentForm.dateFrom,
            dateTo: this.searchEmployeesCurrentForm.dateTo
          });
      }
    }
    public destroyed() {
      this.openRemoveFormModalErrors.length = 0;
      this.setOpenRemoveFormModal(false);
    }

  }
